import newLineCommand from './commands/newline';
import pressEnterCommand from './commands/press_enter';
import undoRedoCommand from './commands/undo_redo';
// import emojiCommand from './commands/emoji';
import computer from './commands/computer';

export default function useCommands() {
  return [computer(), newLineCommand(), pressEnterCommand(), undoRedoCommand()];
}
